// extracted by mini-css-extract-plugin
export default {"mobileHeader":"Header_mobileHeader__+v5fi","desktopHeader":"Header_desktopHeader__-4ilS","menuIcon":"Header_menuIcon__6mgF0","drawerContent":"Header_drawerContent__mUsZi"};